<template>
    <div class="home-div header_black header-custom nqt-header">
        <div class="header-maxwidth">
            <!-- PC -->
            <template v-if="!mobile">
                <!-- Left -->
                <div class="div-left">
                    <ul class="ul-logo">
                        <!-- Logo -->
                        <li id="logo" class="logoImg in_pc">
                            <div class="home-div-label">
                                <img :src="$CONST.HEADER.IMG.LOGO" class="logo_top" @click='$emit("goRouter", $CONST.HEADER.ROUTER.HOME)' />
                            </div>
                        </li>
                        
                        <!-- Search -->
                        <li class="searchPage-home in_pc">
                            <div class="search searchPage">
                                <div class="search_box">
                                    <div class="input_outer">
                                        <div class="input-with-select el-input el-input-group el-input-group--append">
                                            <el-input type="text" v-model="keyword" @keyup.enter.native="search()" autocomplete="off" id="text" :placeholder="$t('search.keyWord')" class="el-input__inner" />
                                            <div class="el-input-group__append">
                                                <el-button type="button" @click="search()" class="el-button el-button--default">
                                                    <span>{{$t("courseProgress.search")}}</span>
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                
                <div class="div-right">
                    
                    <!-- Items -->
                    <div class="div-icon">
                        <ul class="ul-for-icon">
                            <template v-if="loginFlag">
                                <!-- school bussiness -->
                                <li :class="[{_active: type == $CONST.HEADER.ITEM.SCHOOLBUSINESS}]" @click='$emit("goRouter", $CONST.HEADER.ROUTER.SCHOOLBUSINESS)'>
                                    <img class="item-img" v-if="type == $CONST.HEADER.ITEM.SCHOOLBUSINESS && !showPopupNotifications" :src="$CONST.HEADER.IMG_ITEM.SCHOOLBUSINESS_ACTIVE" alt="schoolBussiness">
                                    <img class="item-img" v-else :src="$CONST.HEADER.IMG_ITEM.SCHOOLBUSINESS" alt="schoolBussiness">
                                    <span class="cursor">{{$t("home.myLesson")}}</span>
                                </li>

                                <!-- learn analysis -->
                                <li :class="[{_active: type == $CONST.HEADER.ITEM.ANALYSIS}]" @mouseover='showPopupAnalysis = true' @mouseout='showPopupAnalysis = false'>
                                    <img class="item-img" v-if="type == $CONST.HEADER.ITEM.ANALYSIS && !showPopupNotifications" :src="$CONST.HEADER.IMG_ITEM.ANALYSIS_ACTIVE" alt="learnAnalysis">
                                    <img class="item-img" v-else :src="$CONST.HEADER.IMG_ITEM.ANALYSIS" alt="learnAnalysis">
                                    <span class="cursor">{{$t("home.learningAnalysis")}}</span>

                                    <!-- popup analysis -->
                                    <div class="div-hover-nqt pc" :class="{isSchedule: isSchedule}" v-show="showPopupAnalysis">
                                        <div v-if="isSchedule">
                                            <div>
                                                <div class="item-hover lkt_hide_hover">
                                                    <div class="item-hover lkt_hide_hover">
                                                        <span>{{$t('home.courseConditions')}}</span>
                                                    </div>
                                                </div>
                                                <div class="lkt_padding">
                                                    <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.SCHCONDITIONS)'>
                                                        <img :src="$CONST.HEADER.IMG.CONDITIONS_SCHEDULE">
                                                        <span>{{$t('home.schcourseConditions')}}</span>
                                                    </div>
                                                    <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.CONDITIONS)'>
                                                        <img :src="$CONST.HEADER.IMG.CONDITIONS">
                                                        <span>{{$t('home.courseConditions')}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="item-hover lkt_hide_hover">
                                                    <div class="item-hover lkt_hide_hover">
                                                        <span>{{$t('home.performanceAnalysis')}}</span>
                                                    </div>
                                                </div>
                                                <div class="lkt_padding">
                                                    <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.SCHPERFORMANCE)'>
                                                        <img :src="$CONST.HEADER.IMG.PERFORMANCE_SCHEDULE">
                                                        <span>{{$t('home.schperformanceAnalysis')}}</span>
                                                    </div>
                                                    <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.PERFORMANCE)'>
                                                        <img :src="$CONST.HEADER.IMG.PERFORMANCE">
                                                        <span>{{$t('home.performanceAnalysis')}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.CONDITIONS)'>
                                                <img :src="$CONST.HEADER.IMG.CONDITIONS">
                                                <span>{{$t('home.courseConditions')}}</span>
                                            </div>
                                            <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.PERFORMANCE)'>
                                                <img :src="$CONST.HEADER.IMG.PERFORMANCE">
                                                <span>{{$t('home.performanceAnalysis')}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <!-- course online -->
                                <li :class="[{_active: type == $CONST.HEADER.ITEM.LIVE}]" @click='$emit("goRouter", $CONST.HEADER.ROUTER.LIVE)'>
                                    <img class="item-img" v-if="type == $CONST.HEADER.ITEM.LIVE && !showPopupNotifications" :src="$CONST.HEADER.IMG_ITEM.LIVE_ACTIVE" alt="learnAnalysis">
                                    <img class="item-img" v-else :src="$CONST.HEADER.IMG_ITEM.LIVE" alt="learnAnalysis">
                                    <span class="cursor">{{ $t("home.liveMessage") }}</span>
                                    <span class="mess" v-if="totalCourseOnline">{{totalCourseOnline}}</span>
                                </li>

                                <!-- notification -->
                                <li :class="[{_active: showPopupNotifications}]">
                                    <img class="item-img" v-if="showPopupNotifications" :src="$CONST.HEADER.IMG_ITEM.NOTIFICATION_ACTIVE" @click="showPopupNotifications = false" alt="notification">
                                    <img class="item-img" v-else :src="$CONST.HEADER.IMG_ITEM.NOTIFICATION" @click="showPopupNotifications = true, $refs.componentNotification.init()" alt="notification">
                                    <span class="cursor">{{$t('new.title86')}}</span>
                                    <span class="mess" v-if="totalComment"></span>

                                    <!-- component notification -->
                                    <notification v-show="showPopupNotifications" @close="showPopupNotifications = false" ref="componentNotification"/>

                                    <!-- background -->
                                    <div class="bg_close_notification" v-if="showPopupNotifications" @click="showPopupNotifications = false"></div>
                                </li>
                            </template>
                        </ul>

                        <!-- user login -->
                        <div class="ul-user" :class="[{_no_login: !loginFlag}]">
                            <template v-if="loginFlag">
                                <div class="hover-user" @mouseover='showPopupUser = true' @mouseout='showPopupUser = false'>
                                    <img class="icon-img avatar" :src="user.avatar" @error="setAltStudent"/>
                                    <span>{{user.name}}</span>

                                    <!-- popup manager -->
                                    <div class="div-hover-nqt" v-show="showPopupUser">
                                        <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.PERSONSET)'>
                                            <img :src="$CONST.HEADER.IMG.PROFILE">
                                            <span>{{$t('personSet.personInfo')}}</span>
                                        </div>
                                        <template v-if="user.type != 2">
                                            <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.MANAGE_STUDENT)'>
                                                <img :src="$CONST.HEADER.IMG.MANAGE_STUDENT">
                                                <span>{{$t('manage.student')}}</span>
                                            </div>
                                            <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.MANAGE_LESSON)'>
                                                <img :src="$CONST.HEADER.IMG.MANAGE_LESSON">
                                                <span>{{$t('manage.lesson')}}</span>
                                            </div>
                                            <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.MANAGE_ATTENDANCE)'>
                                                <img :src="$CONST.HEADER.IMG.MANAGE_ATTENDANCE">
                                                <span>{{$t('manage.attendance')}}</span>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <img class="icon-img" :src="$CONST.HEADER.IMG.QUITE" @click='$emit("quite")'/>
                            </template>

                            <template v-else>
                                <span @click='$emit("showLogin", "login")'>{{$t("home.notLogin")}}</span>
                                <img class="icon-img" :src="$CONST.HEADER.IMG.LOGIN" @click='$emit("showLogin", "login")'/>
                            </template>
                        </div>
                    </div>

                    <!-- Langgues -->
                    <div class="ngonngu">
                        <ul class="ul-ngonngu">
                            <li class="translate" @mouseover='showPopupLanguage = true' @mouseout='showPopupLanguage = false'>
                                <div class="flag_box">
                                    <img class="flag" :src="$CONST.HEADER.IMG.ZH" v-if="language == $CONST.COMMON.NUMBER.ONE" />
                                    <img class="flag" :src="$CONST.HEADER.IMG.EN" v-if="language == $CONST.COMMON.NUMBER.TWO" />
                                    <img class="flag" :src="$CONST.HEADER.IMG.JA" v-if="language == $CONST.COMMON.NUMBER.THREE" />
                                    <img class="flag" :src="$CONST.HEADER.IMG.VI" v-if="language == $CONST.COMMON.NUMBER.FOUR" />
                                </div>
                                <dl class="translate_type" v-show="showPopupLanguage">
                                    <dd class="cursor flag_in" @click='$emit("changeLanguage", $CONST.HEADER.LANGUAGE.VI)'>
                                        <img :src="$CONST.HEADER.IMG.VI" class="flag_img" />
                                    </dd>
                                    <dd class="cursor flag_in" @click='$emit("changeLanguage", $CONST.HEADER.LANGUAGE.EN)'>
                                        <img :src="$CONST.HEADER.IMG.EN" class="flag_img" />
                                    </dd>
                                    <dd class="cursor flag_in" @click='$emit("changeLanguage", $CONST.HEADER.LANGUAGE.JA)'>
                                        <img :src="$CONST.HEADER.IMG.JA" class="flag_img" />
                                    </dd>
                                    <dd class="cursor flag_in" @click='$emit("changeLanguage", $CONST.HEADER.LANGUAGE.ZH)'>
                                        <img :src="$CONST.HEADER.IMG.ZH" class="flag_img" />
                                    </dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>

            <!-- Mobile -->
            <template v-if="mobile">
                <!-- loggo -->
                <div class="home-div-label">
                    <img :src="$CONST.HEADER.IMG.LOGO" class="logo_top" @click='$emit("goRouter", $CONST.HEADER.ROUTER.HOME)' />
                </div>

                <!-- Search mobile -->
                <div class="div-search">
                    <ul class="ul-search">
                    <li class="searchPage-home in_pc">
                        <div class="search searchPage">
                        <div class="search_box">
                            <div class="input_outer">
                            <div class="input-with-select el-input el-input-group el-input-group--append">
                                <el-input type="text" v-model="keyword" @keyup.enter.native="search()" autocomplete="off" id="text" :placeholder="$t('search.keyWord')" class="el-input__inner"/>
                                <div class="el-input-group__append">
                                <el-button type="button" @click="search()" class="el-button el-button--default">
                                    <span>{{$t("courseProgress.search")}}</span>
                                </el-button>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </li>
                    </ul>
                    <div class="bg-search" @click="showSearch = false"></div>
                </div>

                <!-- Langgues -->
                <div class="ngonngu mb">
                    <div class="mcs">
                        <img :src="$CONST.HEADER.IMG.SEARCH" @click='showSearch = true'/>
                    </div>
                    <ul class="ul-ngonngu">
                        <li class="translate" @mouseover='showPopupLanguage = true' @mouseout='showPopupLanguage = false'>
                            <div class="flag_box">
                                <img class="flag" :src="$CONST.HEADER.IMG.ZH" v-if="language == $CONST.COMMON.NUMBER.ONE" />
                                <img class="flag" :src="$CONST.HEADER.IMG.EN" v-if="language == $CONST.COMMON.NUMBER.TWO" />
                                <img class="flag" :src="$CONST.HEADER.IMG.JA" v-if="language == $CONST.COMMON.NUMBER.THREE" />
                                <img class="flag" :src="$CONST.HEADER.IMG.VI" v-if="language == $CONST.COMMON.NUMBER.FOUR" />
                            </div>
                            <dl class="translate_type" v-show="showPopupLanguage">
                                <dd class="cursor flag_in" @click='$emit("changeLanguage", $CONST.HEADER.LANGUAGE.VI)'>
                                    <img :src="$CONST.HEADER.IMG.VI" class="flag_img" />
                                </dd>
                                <dd class="cursor flag_in" @click='$emit("changeLanguage", $CONST.HEADER.LANGUAGE.EN)'>
                                    <img :src="$CONST.HEADER.IMG.EN" class="flag_img" />
                                </dd>
                                <dd class="cursor flag_in" @click='$emit("changeLanguage", $CONST.HEADER.LANGUAGE.JA)'>
                                    <img :src="$CONST.HEADER.IMG.JA" class="flag_img" />
                                </dd>
                                <dd class="cursor flag_in" @click='$emit("changeLanguage", $CONST.HEADER.LANGUAGE.ZH)'>
                                    <img :src="$CONST.HEADER.IMG.ZH" class="flag_img" />
                                </dd>
                            </dl>
                        </li>
                    </ul>
                </div>

                <div class="div-user-footer">
                    <div class="mobile-menu">
                        <!-- user -->
                        <template v-if="loginFlag">
                            <div class="ul-user top-footer">
                                <img class="icon-img avatar" :src="user.avatar"/>
                                <span>{{user.name}}</span>
                                <img class="icon-img" :src="$CONST.HEADER.IMG.QUITE" @click='$emit("quite"); showMenu = false'/>
                            </div>
                        </template>

                        <!-- guest -->
                        <template v-if="!loginFlag">
                            <div class="ul-user top-footer">
                                <span @click='$emit("showLogin", "login")'>{{$t("home.notLogin")}}</span>
                                <img class="icon-img" :src="$CONST.HEADER.IMG.LOGIN" @click='$emit("showLogin", "login"); showMenu = false'/>
                            </div>
                        </template>

                        <!-- Footer mobile -->
                        <template v-if="user.type != null && user.type != 2">
                            <div class="footer-header-nqt teacher" @click="showMenu = false">
                                <div v-if="this.$lang() == 4 && this.checkGeneralEnvironment() == 4" class="show-footer2 home_footer1">
                                    <div class="foot-info">
                                    <div class="title">
                                        <h3>Thông tin liên hệ</h3>
                                    </div>
                                    <div>
                                        <div class="block-info">
                                        <img src="/static/images/company.png" vspace="30" alt=""><p>CÔNG TY TNHH TECHZEN</p>
                                        </div>
                                        <div class="block-info">
                                        <img src="/static/images/site.png" vspace="30" alt=""><p>Tầng 10, CVPM, 02 Quang Trung, P.Thạch Thang, Q.Hải Châu, TP.Đà Nẵng</p>
                                        </div>
                                        <div class="block-info">
                                        <img src="/static/images/tax.png" vspace="30" alt=""><p>MST: 0402131940 Sở KT & ĐT Tp..Đà Nẵng cấp ngày 14/01/2022</p>
                                        </div>
                                        <div class="block-info">
                                        <img src="/static/images/phone.png" vspace="30" alt=""><p>0236 6281189</p>
                                        </div>
                                        <div class="block-info">
                                        <img src="/static/images/email2.png" vspace="30" alt=""><p>studyarts-contact@techzen.vn</p>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="footer-icon">
                                    <div class="title">
                                        <h3>Về chúng tôi</h3>
                                    </div>
                                        <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.OPERATION)'>{{$t("home.operation")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.FAQ)'>{{$t("home.faq")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.PROTOCOL)'>{{$t("home.service")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.POLICY)'>{{$t("home.policy")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='goContract()'>Hợp đồng dịch vụ</span>
                                        </div>
                                    </div>
                                     <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='goExchange()'>Chính sách giao nhận</span>
                                        </div>
                                    </div>
                                    <a href='http://online.gov.vn/Home/WebDetails/92029'><img alt='' title='' class="logo_top mb_logo_bct" src='/static/images/logoSaleNoti.png'/></a>
                                    </div>
                                </div>
                                <div v-else class="show-footer">
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.OPERATION)'>{{$t("home.operation")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.FAQ)'>{{$t("home.faq")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.PROTOCOL)'>{{$t("home.service")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.POLICY)'>{{$t("home.policy")}}</span>
                                        </div>
                                    </div>
                                     
                                </div>
                            </div>
                            <div class="div-hover-nqt-mb_o" v-if="loginFlag" @click="showMenu = false">
                                <div class="qltr-kh">{{$t('manage.manage_info')}}</div>
                                <div class="ft">
                                    <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.PERSONSET)'>
                                        <img :src="$CONST.HEADER.IMG.PROFILE">
                                        <span>{{$t('personSet.personInfo')}}</span>
                                    </div>
                                    <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.MANAGE_STUDENT)'>
                                        <img :src="$CONST.HEADER.IMG.MANAGE_STUDENT">
                                        <span>{{$t('manage.student')}}</span>
                                    </div>
                                    <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.MANAGE_LESSON)'>
                                        <img :src="$CONST.HEADER.IMG.MANAGE_LESSON">
                                        <span>{{$t('manage.lesson')}}</span>
                                    </div>
                                    <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.MANAGE_ATTENDANCE)'>
                                        <img :src="$CONST.HEADER.IMG.MANAGE_ATTENDANCE">
                                        <span>{{$t('manage.attendance')}}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="footer-header-nqt no-teacher" @click="showMenu = false">
                                <div v-if="this.$lang() == 4 && this.checkGeneralEnvironment() == 4" class="show-footer2 home_footer1">
                                    <div class="foot-info">
                                    <div class="title">
                                        <h3>Thông tin liên hệ</h3>
                                    </div>
                                    <div>
                                        <div class="block-info">
                                        <img src="/static/images/company.png" vspace="30" alt=""><p>CÔNG TY TNHH TECHZEN</p>
                                        </div>
                                        <div class="block-info">
                                        <img src="/static/images/site.png" vspace="30" alt=""><p>Tầng 10, CVPM, 02 Quang Trung, P.Thạch Thang, Q.Hải Châu, TP.Đà Nẵng</p>
                                        </div>
                                        <div class="block-info">
                                        <img src="/static/images/tax.png" vspace="30" alt=""><p>MST: 0402131940 Sở KT & ĐT Tp..Đà Nẵng cấp ngày 14/01/2022</p>
                                        </div>
                                        <div class="block-info">
                                        <img src="/static/images/phone.png" vspace="30" alt=""><p>0236 6281189</p>
                                        </div>
                                        <div class="block-info">
                                        <img src="/static/images/email2.png" vspace="30" alt=""><p>studyarts-contact@techzen.vn</p>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="footer-icon">
                                    <div class="title">
                                        <h3>Về chúng tôi</h3>
                                    </div>
                                        <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.OPERATION)'>{{$t("home.operation")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.FAQ)'>{{$t("home.faq")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.PROTOCOL)'>{{$t("home.service")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.POLICY)'>{{$t("home.policy")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='goContract()'>Hợp đồng dịch vụ</span>
                                        </div>
                                    </div>
                                     <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='goExchange()'>Chính sách giao nhận</span>
                                        </div>
                                    </div>
                                    
                                    <a href='http://online.gov.vn/Home/WebDetails/92029'><img alt='' title='' class="logo_top mb_logo_bct" src='/static/images/logoSaleNoti.png'/></a>
                                    </div>
                                </div>
                                <div v-else class="show-footer">
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.OPERATION)'>{{$t("home.operation")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.FAQ)'>{{$t("home.faq")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.PROTOCOL)'>{{$t("home.service")}}</span>
                                        </div>
                                    </div>
                                    <div class="home_footer3">
                                        <div>
                                            <em>></em>
                                            <span @click='$emit("redirectFooter", $CONST.HEADER.ITEM.POLICY)'>{{$t("home.policy")}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="div-hover-nqt-mb_o" v-if="loginFlag" @click="showMenu = false">
                                <div class="qltr-kh">{{$t('manage.manage_info')}}</div>
                                <div class="ft">
                                    <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.PERSONSET)'>
                                        <img :src="$CONST.HEADER.IMG.PROFILE">
                                        <span>{{$t('personSet.personInfo')}}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="bg-menu" v-show="showMenu" @click="showMenu = false"></div>
                </div>

                <ul class="ul-for-icon _bottom">
                    <template v-if="loginFlag">
                        <!-- home -->
                        <li :class="[{_active: type == $CONST.HEADER.ITEM.HOME}]" @click='$emit("goRouter", $CONST.HEADER.ROUTER.HOME)'>
                            <img class="item-img" v-if="type == $CONST.HEADER.ITEM.HOME && !showPopupNotifications" :src="$CONST.HEADER.IMG_ITEM.HOME_ACTIVE" alt="home">
                            <img class="item-img" v-else :src="$CONST.HEADER.IMG_ITEM.HOME" alt="home">
                        </li>

                        <!-- school bussiness -->
                        <li :class="[{_active: type == $CONST.HEADER.ITEM.SCHOOLBUSINESS}]" @click='$emit("goRouter", $CONST.HEADER.ROUTER.SCHOOLBUSINESS)'>
                            <img class="item-img" v-if="type == $CONST.HEADER.ITEM.SCHOOLBUSINESS && !showPopupNotifications" :src="$CONST.HEADER.IMG_ITEM.SCHOOLBUSINESS_ACTIVE" alt="schoolBussiness">
                            <img class="item-img" v-else :src="$CONST.HEADER.IMG_ITEM.SCHOOLBUSINESS" alt="schoolBussiness">
                            <span class="cursor">{{$t("home.myLesson")}}</span>
                        </li>

                        <!-- learn analysis -->
                        <li :class="[{_active: type == $CONST.HEADER.ITEM.ANALYSIS}]">
                            <img class="item-img" v-if="type == $CONST.HEADER.ITEM.ANALYSIS && !showPopupNotifications" @click="showPopupAnalysis = true" :src="$CONST.HEADER.IMG_ITEM.ANALYSIS_ACTIVE" alt="learnAnalysis">
                            <img class="item-img" v-else :src="$CONST.HEADER.IMG_ITEM.ANALYSIS" @click="showPopupAnalysis = true" alt="learnAnalysis">
                            <span class="cursor">{{$t("home.learningAnalysis")}}</span>

                            <!-- popup analysis -->
                            <div class="div-hover-nqt mb" :class="{isSchedule : isSchedule}" v-show="showPopupAnalysis" @click="showPopupAnalysis = false">
                                <div v-if="isSchedule">
                                    <div>
                                        <div>
                                            <div class="item-hover">
                                                <span>{{$t('home.courseConditions')}}</span>
                                            </div>
                                        </div>
                                        <div class="lkt_padding">
                                            <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.SCHCONDITIONS)'>
                                                <img :src="$CONST.HEADER.IMG.CONDITIONS_SCHEDULE">
                                                <span>{{$t('home.schcourseConditions')}}</span>
                                            </div>
                                            <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.CONDITIONS)'>
                                                <img :src="$CONST.HEADER.IMG.CONDITIONS">
                                                <span>{{$t('home.courseConditions')}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <div class="item-hover">
                                                <span>{{$t('home.performanceAnalysis')}}</span>
                                            </div>
                                        </div>
                                        <div class="lkt_padding">
                                            <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.SCHPERFORMANCE)'>
                                                <img :src="$CONST.HEADER.IMG.PERFORMANCE_SCHEDULE">
                                                <span>{{$t('home.schperformanceAnalysis')}}</span>
                                            </div>
                                            <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.PERFORMANCE)'>
                                                <img :src="$CONST.HEADER.IMG.PERFORMANCE">
                                                <span>{{$t('home.performanceAnalysis')}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.CONDITIONS)'>
                                        <img :src="$CONST.HEADER.IMG.CONDITIONS">
                                        <span>{{$t('home.courseConditions')}}</span>
                                    </div>
                                    <div class="item-hover" @click='$emit("goRouter", $CONST.HEADER.ROUTER.PERFORMANCE)'>
                                        <img :src="$CONST.HEADER.IMG.PERFORMANCE">
                                        <span>{{$t('home.performanceAnalysis')}}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- background -->
                            <div class="bg_close_notification" v-if="showPopupAnalysis" @click="showPopupAnalysis = false"></div>
                        </li>

                        <!-- course online -->
                        <li :class="[{_active: type == $CONST.HEADER.ITEM.LIVE}]" @click='$emit("goRouter", $CONST.HEADER.ROUTER.LIVE)'>
                            <img class="item-img" v-if="type == $CONST.HEADER.ITEM.LIVE && !showPopupNotifications" :src="$CONST.HEADER.IMG_ITEM.LIVE_ACTIVE" alt="learnAnalysis">
                            <img class="item-img" v-else :src="$CONST.HEADER.IMG_ITEM.LIVE" alt="learnAnalysis">
                            <span class="cursor">{{ $t("home.liveMessage") }}</span>
                            <span class="mess" v-if="totalCourseOnline">{{totalCourseOnline}}</span>
                        </li>

                        <!-- notification -->
                        <li :class="[{_active: showPopupNotifications}]">
                            <img class="item-img" v-if="showPopupNotifications" :src="$CONST.HEADER.IMG_ITEM.NOTIFICATION_ACTIVE" @click="showPopupNotifications = false" alt="notification">
                            <img class="item-img" v-else :src="$CONST.HEADER.IMG_ITEM.NOTIFICATION" @click="showPopupNotifications = true, $refs.componentNotificationMoblie.init()" alt="notification">
                            <span class="cursor">{{$t('new.title86')}}</span>
                            <span class="mess" v-if="totalComment"></span>

                            <!-- component notification -->
                            <notification v-show="showPopupNotifications" @close="showPopupNotifications = false" ref="componentNotificationMoblie"/>

                            <!-- background -->
                            <div class="bg_close_notification" v-if="showPopupNotifications" @click="showPopupNotifications = false"></div>
                        </li>

                        <!-- menu -->
                        <li @click='showMenu = true'>
                            <img class="item-img" :src="$CONST.HEADER.IMG.MENU" alt="menu">
                        </li>
                    </template>

                    <template v-else>
                        <!-- login -->
                        <li>
                            <img class="item-img" :src="$CONST.HEADER.IMG.LOGIN" @click='$emit("showLogin", "login")' alt="login">
                        </li>
                        <!-- menu -->
                        <li @click='showMenu = true'>
                            <img style="margin-top: 7px;" class="item-img" :src="$CONST.HEADER.IMG.MENU" alt="menu">
                        </li>
                    </template>
                </ul>
            </template>
        </div>
    </div>
</template>

<script>
    import notification from "@/components/popup/notification.vue";
    import { mapState, mapMutations } from "vuex";
    export default {
        components: {
            notification
        },
        data() {
            return {
                loginFlag: false,
                showMenuUy: false,
                showPopupLanguage: false,
                showPopupAnalysis: false,
                showPopupUser: false,
                showMenu: false,
                showSearch: false,
                showPopupNotifications: false,
                type: null,
                language: null,
                user: {
                    id: null,
                    name: null,
                    type: null,
                    avatar: null
                },
                isSchedule: false,
                keyword: null,
                menu: [
                    {
                        path: this.$CONST.HEADER.ROUTER.HOME,
                        pathName: this.$CONST.HEADER.ITEM.HOME
                    },
                    {
                        path: this.$CONST.HEADER.ROUTER.HOMEPARENTPARENT,
                        pathName: this.$CONST.HEADER.ITEM.HOME
                    },
                    {
                        path: this.$CONST.HEADER.ROUTER.HOMEPARENT,
                        pathName: this.$CONST.HEADER.ITEM.HOME
                    },
                    {
                        path: this.$CONST.HEADER.ROUTER.CONDITIONS,
                        pathName: this.$CONST.HEADER.ITEM.ANALYSIS
                    },
                    {
                        path: this.$CONST.HEADER.ROUTER.PERFORMANCE,
                        pathName: this.$CONST.HEADER.ITEM.ANALYSIS
                    },
                    {
                        path: this.$CONST.HEADER.ROUTER.SCHCONDITIONS,
                        pathName: this.$CONST.HEADER.ITEM.ANALYSIS
                    },
                    {
                        path: this.$CONST.HEADER.ROUTER.SCHPERFORMANCE,
                        pathName: this.$CONST.HEADER.ITEM.ANALYSIS
                    },
                    {
                        path: this.$CONST.HEADER.ROUTER.SCHOOLBUSINESS,
                        pathName: this.$CONST.HEADER.ITEM.SCHOOLBUSINESS
                    },
                    {
                        path: this.$CONST.HEADER.ROUTER.SCHOOLBUSINESS_VN,
                        pathName: this.$CONST.HEADER.ITEM.SCHOOLBUSINESS
                    },
                    {
                        path: this.$CONST.HEADER.ROUTER.SCHOOLBUSINESS_SCHEDULE,
                        pathName: this.$CONST.HEADER.ITEM.SCHOOLBUSINESS
                    },
                    {
                        path: this.$CONST.HEADER.ROUTER.LIVE,
                        pathName: this.$CONST.HEADER.ITEM.LIVE
                    }
                ],
            };
        },
        created () {
            this.language = this.$lang();

            // Check: is page
            this.detectType();

            // load user info
            this.autoUserInfo();

            // check is schedule
            this.checkSchedule();

            if (this.$route.path != this.$CONST.HEADER.ROUTER.CURRICULUM && this.$route.path != this.$CONST.HEADER.ROUTER.AICOURSE) {

                // get notificatons of the course online
                this.autoGetTotalCourseOnline();

                // get notificatons of the course
                this.autoGetNofications();
            }

            // check login
            this.loginFlag = this.user["id"] ? true : this.loginFlag;

            // Calc time
            if (window.sessionStorage.getItem("id")) {
                let timeLoadInfoUser = 2;
                setInterval(() => {
                    if (timeLoadInfoUser==0) {
                        let avatar = window.sessionStorage.getItem("headImagePath");
                        if (avatar) {
                            this.user.avatar = avatar;
                        } else {
                            if (parseInt(window.sessionStorage.getItem("gender"))==2) {
                                this.user.avatar = "static/images/SA-ava-nu.png";
                            } else {
                                this.user.avatar = "static/images/profile.jpg";
                            }
                        }
                        timeLoadInfoUser = 3;
                    }
                    timeLoadInfoUser = timeLoadInfoUser - 1;
                }, 1000);
            }
        },
        computed: {
            // store
            ...mapState({
                mobile: (state) => state.header.mobile,
                totalComment: (state) => state.header.totalComment,
                totalCourseOnline: (state) => state.header.totalCourseOnline
            }),
        },
        methods: {
            goContract(){
            this.$router.push({
                path: "/home/contract_new"
            });
            },
             goExchange(){
            this.$router.push({
                path: "/home/exchange"
            });
            },
            // go to page
            goRouter: function (url) {
                this.$emit("goRouter", url);
            },
            setAltStudent(event) { 
               event.target.src = "../../../static/images/profile.jpg" ;
            },
            // search course
            search: function () {
                if (this.keyword == null || this.keyword == "") return;

                let keyword = this.keyword;
                this.keyword = null;

                this.showSearch = false;

                this.$router.push({
                    path: this.$CONST.HEADER.ROUTER.SEARCH,
                    query: {
                        keyword: keyword
                    }
                });
            },

            detectType: function () {
                let type = null;
                let key = this.menu.findIndex(item => item.path == this.$route.path);

                if (key >= 0) {
                    type = this.menu[key].pathName;
                }

                this.type = type;
            },

            // get total notificaton when change router
            autoGetNofications: async function () {
                let total = 0;

                let result = await this.getNumberOfUnreadComment({userId: this.user.id, languageType: this.language});
                total = result || total;

                this.setTotalComment(total);
            },

            // get total course online when change router
            autoGetTotalCourseOnline: async function () {
                let total = 0;

                let result = await this.getNumberOfUnreadMessages({languageType: this.language});
                total = result || total;

                this.setTotalCourseOnline(total);
            },

            // get total notificaton
            getNumberOfUnreadComment: function (params) {
                if (this.user.id == null || this.user.id == '') return false;
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseCommentListNew", params)
                        .then((response) => {
                            resolve(response.data.length);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // get total course online
            getNumberOfUnreadMessages: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/home/getNumberOfUnreadMessages", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // check login when change router
            autoCheckLogin: function () {
                let courseLoginFlg = window.sessionStorage.getItem("course_login_flg");
                let token = window.document.cookie.match('(^|;) ?token-dongdu=([^;]*)(;|$)');

                token = token ? token[2] : null;

                if (!token && parseInt(courseLoginFlg) == 1) {
                    let _date = new Date();
                    _date.setDate(_date.getDate() - 1);
                    _date.toGMTString();
                    document.cookie = "token-dongdu='';expires=" + _date.toGMTString();
                    document.cookie = "remember='';expires=" + _date.toGMTString();
                    window.sessionStorage.clear();
                    localStorage.clear();
                    this.$router.push({path: this.$CONST.HEADER.ROUTER.HOME});
                    window.location.reload();
                }
            },

            // load avatar auto follow time
            autoUserInfo: function () {

                let avatar = window.sessionStorage.getItem("headImagePath");

                this.user.id = window.sessionStorage.getItem("id");
                this.user.name = window.sessionStorage.getItem("name");
                this.user.type = window.sessionStorage.getItem("userType");
                if (avatar) {
                    this.user.avatar = avatar;
                } else {
                    if (parseInt(window.sessionStorage.getItem("gender"))==2) {
                        this.user.avatar = "static/images/SA-ava-nu.png";
                    } else {
                        this.user.avatar = "static/images/profile.jpg";
                    }
                }
            },

            // check is schedule
            checkSchedule () {
                this.$api
                    .post("/coursesPurchase/getScheduleStudent", {
                        userId: window.sessionStorage.getItem("id")
                    })
                    .then((response) => {
                        response.data != 0 ? this.isSchedule = true : this.isSchedule = false;
                    });
            },

            ...mapMutations("header", ["setTotalComment", "setTotalCourseOnline"]),
        },
        watch: {
            $route(to, form) {

                // check login
                this.autoCheckLogin();

                // Check: is page
                this.detectType();

                // load user info
                this.autoUserInfo();

                // checkSchedule
                this.checkSchedule();

                if (to.path != this.$CONST.HEADER.ROUTER.CURRICULUM && to.path != this.$CONST.HEADER.ROUTER.AICOURSE) {

                    // get notificatons of the course online when change router
                    this.autoGetTotalCourseOnline();

                    // get notificatons of the course when change router
                    this.autoGetNofications();
                    
                }
            },

            showMenu(value) {
                const self = this;
                if (value) {
                    document.getElementsByTagName("body")[0].classList.add("show-menu");
                } else {
                    document.getElementsByTagName("body")[0].classList.remove("show-menu");
                }
            },

            showSearch(value) {
                var el_title = document.querySelector('.nqt_titl_7283');
                if (value) {
                    document.getElementsByTagName("body")[0].classList.add("show-search");

                    if (el_title != null) {
                        el_title.classList.add("hide_title");
                    }
                } else {
                    document.getElementsByTagName("body")[0].classList.remove("show-search");

                    if (el_title != null) {
                        el_title.classList.remove("hide_title");                        
                    }
                }
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .lkt_hide_hover:hover span {
        color: #fff !important;
        cursor: unset !important;
    }
    .lkt_padding {
        padding-left: 24px;
    }
    /* new */
    .icon-img {
        display: block !important;
    }
    .ngonngu.mb {
        position: absolute;
        right: 10px;
        width: auto;
    }
    .mcs {
        width: 50px;
        height: 60px;
        display: flex;
    }
    .mcs img {
        width: 30px;
        height: 30px;
        margin: auto;
    }
    .div-hover-nqt.mb {
        z-index: 3;
        top: auto;
        bottom: 60px;
        width: max-content;
    }
    .div-hover-nqt.pc {
        width: max-content;
    }
    ._bottom {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 60px;
        background-color: #0071c5;
    }
    .footer-header-nqt.teacher {
        height: calc(100vh - 249px);
        overflow: auto;
        overflow-x: hidden;
    }
    .footer-header-nqt.no-teacher {
        height: calc(100vh - 160px)
    }
    .qltr-kh {
        background: #404040;
        color: #fff;
        text-align: center;
        font-size: 16px;
        padding: 10px;
    }
    .div-hover-nqt-mb {
        background: #555;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 260px;
        color: #fff;
    }
    .div-hover-nqt-mb_o {
        background: #555;
        bottom: 0;
        left: 0;
        width: 260px;
        color: #fff;
    }
    .div-hover-nqt-mb_o._activeP {
        position: fixed;
    }
    .div-hover-nqt-mb_o .ft {
        padding: 10px;
    }
    ._active_ft {
        left: 0;
    }
    .mobile-menu {
        z-index: 100;
    }
    .bg-menu {
        display: block!important;
        width: 100%;
        height: 100%;
        background: transparent;
        top: 0;
        left: 0;
    }
    .top-footer {
        width: 100% !important;
        padding: 15px 15px;
        height: 70px;
        background-color: #2f3640;
    }
    .bg_close_notification {
        position: fixed;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 2;
        background-color: #80808000;
    }
    .hover-user {
        display: flex;
        height: 100%;
        width: 80%;
    }
    ._quit {
        width: 20%;
    }
    .item-hover span {
        transition: ease 0.5s;
    }
    .item-hover:hover span {
        color: #8aff00;
    }
    .div-hover-nqt {
        flex-direction: column;
        position: absolute;
        top: 60px;
        min-width: 220px;
        padding: 5px 10px;
        background: #323232;
        align-items: flex-start;
        box-shadow: rgba(0 0 0 / 10%) 0px 6px 24px 0px;
    }
    .item_svg {
        display: flex;
        flex-direction: column;
    }
    .ul-user {
        cursor: pointer;
    }
    .ul-user._no_login {
        justify-content: flex-end;
    }
    .ul-user .icon-img.avatar {
        border-radius: 50%;
    }
    .ul-user span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        margin: auto 4px;
        color: #fff;
    }
    .ul-user .icon-img {
        width: 32px;
        height: 32px;
        margin: auto 0;
    }
    .div-right .div-icon {
        display: flex;
    }
    .item-hover img {
        width: 24px;
        height: 24px;
    }
    .item-hover span {
        margin-left: 4px;
        font-size: 13px;
    }
    .item-hover {
        display: flex;
        height: 30px;
        justify-content: flex-start;
        align-items: center;
    }
    .ul-user {
        display: flex;
        width: 30%;
    }
    .div-right .div-icon ul.ul-for-icon li img.item-img,
    ._bottom.ul-for-icon li img.item-img {
        width: 40px;
        margin: auto;
    }
    .div-right .div-icon ul.ul-for-icon li{
        display: block;
        position: relative;
        cursor: pointer;
    }
    ._bottom.ul-for-icon li {
        display: block;
        position: relative;
        cursor: pointer;
        padding: 2px 5px!important;
    }
    ._bottom.ul-for-icon li span.cursor{
        display: none;
    }
    .div-right .div-icon ul.ul-for-icon li .mess,
    ._bottom.ul-for-icon li .mess {
        background-color: red;
        color: #fff;
        position: absolute;
        top: 2px;
        right: 18px;
        border-radius: 50%;
        height: 14px !important;
        width: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    ._bottom.ul-for-icon {
        justify-content: space-around;
        width: 100%;
    }
    .div-right .div-icon ul.ul-for-icon {
        justify-content: flex-end;
        width: 70%;
    }
    .div-left {
        width: 520px;
    }
    .div-left ul li.searchPage-home.in_pc {
        display: flex;
    }
    .div-right {
        width: calc(100% - 520px);
    }
    .ngonngu {
        width: 8%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .div-icon {
        width: 100%;
    }



    /* old */
    .lkt_ava-user:hover {
        cursor: pointer;
    }

    .footer-header-nqt .home_footer3 span {
        display: block;
        color: rgb(204, 204, 204);
    }
    .searchPage .el-input__inner {
        color: black;
    }
    .close_search {
        width: 60px;
        height: 60px;
        padding: 15px;
    }
    .nqt-manage {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        position: absolute;
        top: 60px;
        min-width: 220px;
        padding: 5px 10px;
        background: #323232;
        -webkit-box-align: start;
        align-items: flex-start;
        box-shadow: rgba(0 0 0 / 10%) 0px 6px 24px 0px;
    }

    .nqt-manage div {
        font-size: 13px;
        color: #fff;
        padding: 10px 0 5px;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
    }

    .nqt-manage div:hover {
        opacity: 0.8;
    }

    .nqt__svg_header {
        background: none !important;
    }
    .nqt__svg_header svg {
        fill: #ffffffd6;
    }
    .cst__active svg {
        fill: #86fb06;
    }
    /* media query */
    @media (max-width:480px) {
        .isSchedule {
            left: -100px;
        }
    }
    @media (max-width: 1112px){
    .mobile-menu {
        width: 80%;
        background-color: #555;
        }
    .home_footer1 .foot-logo{
    width: 300px;
    }
    .home_footer1 .foot-logo img{
    height: auto !important;
    width: 100%;
    }
    .home_footer1 .foot-info{
    width: 100%;
    padding: 10px 10px;
    }
    .home_footer1 .foot-info .block-info{
        display: flex;
    }
    .home_footer1 .foot-info img{
    display: inline-block;
    vertical-align: sub;
    width: 17px;
    height: 17px;
    margin-right: 5px;
    }
    .home_footer1 .foot-info .title h3{
    padding-bottom: 15px;
    color: #fff;
    font-size: 18px;
    padding:20px 0px;
    }
    .home_footer1 .foot-info p{
    padding-bottom: 15px;
    color: #fff;
    font-size: 13px;
    display: inline-block;
    }
    .home_footer1 .footer-icon{
    display: block !important;
    width: 100%;
    }
    .home_footer1 .footer-icon .title h3{
    padding-bottom: 15px;
    color: #fff;
    font-size: 18px;
    padding: 10px;
    }
    .home_footer1 .home_footer4{
    text-align: left;
    margin: 0px;
    line-height: 30
    }
    .div-hover-nqt-mb_o{
        width: 100%;
    }
    .mb_logo_bct {
        width: auto;
        margin: 12px;
    }
    .div-hover-nqt{
    	position: absolute;
    	top: -70px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/header/header.vue